import { ParkingProductType } from "../models";
import { ContractType } from "../models/ParkingProductModel";

export type ProductContractTypeFilter = {
    contractType?: ContractType;
    productType?: ParkingProductType;
};

export function appendParams(params: URLSearchParams, productContractTypeFilter: any) {
    for (const [key, val] of Object.entries(productContractTypeFilter)) {
        if (val) {
            params.append(key, val.toString());
        }
    }
}

